<template>
    <split-pane  :min-percent='10' :default-percent='16' split="vertical">
        <template slot="paneL" >
            <el-input placeholder="请输入关键字进行过滤" v-model="filterText" size="medium"  ></el-input> 
            <el-tree :data="treeData" 
                        :props="defaultProps" 
                        @node-click="handleNodeClick" 
                        node-key="id"    
                        default-expand-all     
                        :style="{background:'#7f8f9',overflow:'auto',height: scrollerHeight}"
                        highlight-current
                        v-loading="loadingtree"
                        element-loading-text="加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(255, 251, 255, 0.8)"    
                        :filter-node-method="filterNode"
                        ref="eltree"
                        :expand-on-click-node="false">
                <template v-slot="{node,data}">                                     
                    <span v-if="data.id ==0 "  >
                        <span  style="color:#409eff;font-size:14px;"><i class="iconfont icon-mokuai1" style="color:#409eff;font-size:18px;"></i> {{ node.label}} </span>
                    </span>                  
                    <span v-else  > 
                        <span style="color:#2b85e4;font-size:12px;"><i class="iconfont icon-fenzhijiedian" style="margin-right:5px;"></i> {{ node.label}} 【 {{data.id}} 】 </span>
                    </span>
                </template>
            </el-tree>
        </template>
        <template slot="paneR">         
            <div style=" display:flex; width:100%; background:#f5f6f7; ">
                    <div style="min-width:1000px;display:flex;line-height:30px;height:35px;padding-top:2px">
 
                        <el-button style="width:100px"  @click="selRec" type="primary" icon="iconfont icon-chenggong1" size="mini"> 确认选择 </el-button>
                        <span style="margin-left:20px;">
                             <el-select v-model="stfgSet"  size="small" @change="stfgChange(stfgSet)" style="width:110px">
                                <el-option label="所有状态" value="ALL"></el-option>
                                <el-option label="待审核" value="N"></el-option>
                                <el-option label="已审核" value="Y"></el-option>
                            </el-select>
                        </span>
                        <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:130px;margin-left:20px; ">
                            <span v-for="item in tabArr" :key='item.key'>
                                <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                            </span>
                        </el-select>         
                        <el-input @keyup.enter.native="qryTabData" placeholder="请输入查询值" v-model="txtparam" size="small" style="width:320px;height:30px ">
                            <el-select v-model="oper" slot="prepend" size="small" style="width:110px; ">
                                <span v-for="item in operArr" :key='item.IDSEQ'>
                                    <el-option :label="item.CNAME" :value="item.SUBNO"  ></el-option>
                                </span>
                            </el-select>
                            <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                        </el-input>
                        <el-select v-model="selparam2"  placeholder="请选择列名" clearable size="small" style="width:130px;margin-left:10px; ">
                            <span v-for="item in tabArr" :key='item.key'>
                                <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                            </span>
                        </el-select>         
                        <el-input @keyup.enter.native="qryTabData" placeholder="请输入查询值" v-model="txtparam2" size="small" style="width:320px;height:30px ">
                            <el-select v-model="oper2" slot="prepend" size="small" style="width:110px; ">
                                <span v-for="item in operArr" :key='item.IDSEQ'>
                                    <el-option :label="item.CNAME" :value="item.SUBNO"  ></el-option>
                                </span>
                            </el-select>
                            <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" style="color:#409eff"></el-button>
                        </el-input> 
                    </div>
                </div> 
                <el-table  :data="tabData" 
                        border                            
                        disabled-hover
                        style="overflow:auto;margin-top:1px;"
                        size="small"
                        :height="tabHeight" 
                        :row-key="getRowKey"  
                        ref="tabref" 
                        @row-click="rowClick"
                        @row-dblclick="selRec"
                        highlight-current-row>
 
                        <el-table-column  v-for="(item,index) in tabArr.filter(item=>item.thide=='N')" :key="index"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"    
                                                   
                            
                            :min-width="item.width">
                            <template  slot-scope="scope" >
                                <el-checkbox v-if="item.edcss=='checkbox'" disabled  true-label="Y"  false-label="N" v-model="scope.row[item.key]" > &nbsp;</el-checkbox> 
                                <el-image v-else-if="item.key=='IMGPATH'" style="width:100%;height:20px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">
                                    <div slot="error"><i class="el-icon-picture-outline"></i></div>
                                </el-image>
                                <span v-else v-text="scope.row[item.key]"></span>
                            </template>
                        </el-table-column> 
 
                </el-table>  
                <div style="margin-top: 3px; overflow: hidden;display:flex;width:100%;background:#f7f8f9;line-height:30px;height:35px;font-size:12px;padding-left:5px">
                    <div style="float: left;">
                        <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
                    </div>
                    <div style="color:#606266;margin-right:8px;margin-left:10px;font-size:12px;width:35px;">每页</div>
 
                    <el-select v-model="rowSize" size="small" style="width:80px;"  @change="initPage">
                        <el-option 
                            v-for="item in pageList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div> 
 
                <!-- 提示框 -->
                <el-dialog  :show-close="false" :visible.sync="promtWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                    <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                        <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
                    </div>
                    <span>{{prompt}}</span>
                    <span slot="footer"  >
                        <el-button type="primary" size="small" @click="promtWin = false">确 定</el-button>
                    </span>
                </el-dialog>
 
        </template>
    </split-pane> 
</template>
<script>
import { getTabColOrData,getBaseData } from '../../api/user';
import {getDate } from '../../api/Select' 
 
//局部注册
export default {
 
    data () {
        return {
            typeWin:false,
            typeSel:false,
            nodeLabel:'物料类别',
            treeid:'0',  
            filterText:'',  
            defaultProps: {  //el-tree 默认字段属性
                children: 'children',
                id:'id',
                icon:'icon',
                label: 'label'
            },
            ishand:'',
            cname:'',
            stfg:'',
            sortby:'',
            drawer:false,
            addProp:false,
            propFlag:'create',
            upFile:{},
            contRow:{},
            showViewer:false,
            Accept: "png,jpg,jpeg", //上传文件格式限制
            acceptPdf:"pdf",
            saveFlag:false,
            promtWin:false,
            prompt:'',
            stfgCss:'',
            operArr:[],
            perWin:false,
            stfgColor:'',
            treeData: [],
            loadingtree:false, 
            matno:'',
            matdesc:'',
            matnm:'',
            unitnm:'',
            prc:'',// 商品价格
            mattynm:'',
            disabled:false, //新增权限制
            stfgSet:'ALL',
            idseq:'', //菜单主键
            tabData:[], //表数据
            allData:[],
            tabArr:[], //表列
            comboArr:{},
            oper:'like',
            txtparam2:'',
            selparam2:'',
            oper2:'like',
            txtparam:'',
            selparam:'IDNO',
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            dataCount:0,
            rowSize:50,
            goPage:'',
            notNull:[],
            current:1,
            stfgBool:true,
            pageList: [ {
                value: 50,
                label: '50'
                },   {
                value: 100,
                label: '100'
            }],
            v_row:{},
        }
    },
    mounted () { 
        //操作符
        getBaseData('xuper_auth/getTableRecMany','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
    },
    computed: {
        scrollerHeight: function() {
            return (window.innerHeight - 160) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 190) + 'px';
        }, 
    },
    components: {
 
    },
    created () {       
        if (this.v_username){ 
            //查询数据
            this.qryTabData()
            this.getTabField() //表列字段
            this.getData()
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
        filterText(val) {
            this.$refs.eltree.filter(val);
        }
    },
    methods: {
        selRec(){
            if (this.v_row){
                this.$emit('child-matno',this.matno,this.matnm,this.matdesc,this.unitnm,this.prc,this.mattynm)
                this.$emit('child-matobj',this.v_row)
            }else{
                this.promtWin=true
                this.prompt='请选择一条记录'
            }
        },
        rowClick(row){
            this.v_row =JSON.parse(JSON.stringify(Object.assign(row,{'MATNO':row['IDNO']})))
        },
 
        //节点过滤
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1||data.id.indexOf(value) !== -1
        },
  
        //节点点击
        handleNodeClick(data ){
            this.nodeLabel=data.label;            
            this.treeid =data.id
            this.queryEvent(this.stfgSet,data.id)
        },
  
        //产品明细
        getMatList(cond){
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'modelno', p_value:'MAT',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond,p_table:'V_BS_mat'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.tabData=res.result
                    this.allData =this.tabData
                    this.initPage() 
                }else{
                    this.promtWin=true
                    this.prompt=res.result
                }
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.tabref.doLayout();
                })
            }) 
        },
 
        //跳至页面
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.promtWin=true
                this.prompt='请输入跳至页数'
            }
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tabData = this.allData          
            }else{
                this.tabData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize;
            this.tabData = this.allData.slice(_start,_end);
        },
 
        getRowKey(row){
            return row.IDSEQ
        },
        //查询
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%' + this.txtparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam +this.oper+'\''+this.txtparam+'\''
                }
            }
            if (this.selparam2){ //列1
                if (this.oper2==='like'){
                    cond_=cond_+' and '+this.selparam2+' like \'%' + this.txtparam2+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam2 +this.oper2+'\''+this.txtparam2+'\''
                }
            }
            if (this.stfgSet!=='ALL'){
               cond_ =cond_+' and stfg=\''+this.stfgSet +'\''
            }  
            this.getMatList(  cond_)        
        },
 
        //状态查询
        stfgChange(val){
            this.queryEvent( val,this.treeid)
        },
        //左边菜单
        getData() {  
            var vm=this;
            this.loadingtree=true
            this.$axios({
                method: 'post',
                url:'xuper_auth/getElTreeData' ,
                data: {p_table:'v_mat_TYPE',p_cond:' and corpid=\''+this.v_corpid+'\''}
            }).then(function(res){                  
                vm.treeData =res.result   
                if(res.result.length > 0 ){
                    vm.$nextTick(() =>{
                        //使用setCurrentKey方法的时候必须将其放在nextTick中,要等数据更新渲染完再调用,否则找不到对应元素
                        vm.$refs.eltree.setCurrentKey(vm.treeid)
                    })
                }  
                vm.loadingtree =false           
            })                              
        },
        queryEvent(val,nodeid){
            if(nodeid!=='0'){
                if (val=='ALL'){
                    this.getMatList(' and Matty=\''+nodeid+'\'')
                }else if (val=='Y'){ //审核
                    this.getMatList(' and Matty=\''+nodeid+'\' and stfg=\'Y\'')
                }else if (val=='N'){ //未审核
                    this.getMatList(' and Matty=\''+nodeid+'\' and stfg=\'N\'')
                }else if (val=='X'){  
                    this.getMatList(' and Matty=\''+nodeid+'\' and stfg=\'X\'')
                }
            }else{
                if (val=='ALL'){
                    this.getMatList('')
                }else if (val=='Y'){ //审核
                    this.getMatList('  and stfg=\'Y\'')
                }else if (val=='N'){ //未审核
                    this.getMatList('  and stfg=\'N\'')
                }else if (val=='X'){  
                    this.getMatList(' and stfg=\'X\'')
                }
            }
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
 
        }
    }
}
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .oneMenu{
        line-height:35px;
        text-align:left;
        padding-left:35px;
        font-size:14px;
        color:white;
        background-color: #409eff;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#f4f6f8;
    }
    .twoMenu{
        display:flex;
        flex-direction:column;
        line-height:40px;
        background:white;
        padding-left:35px;
 
    }
    .twoMenu:hover{
        cursor: pointer;
        color:#409EFF;
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
 
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
